import styled from 'styled-components';

export const BottomFixedContainer = styled.div.attrs({ 'data-testid': 'bottom-fixed-container' })`
  position: fixed;
  width: 100vw;
  bottom: 0;
  z-index: 1000;
`;
